"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockPatternRule = void 0;
var blockPatternRule = function (mediafileId, blockIds, mediafileBlocks) {
    if (!blockIds.length)
        return;
    var blockLength = mediafileBlocks.length;
    for (var i = 0; i < blockLength; i++) {
        if (mediafileBlocks[i][0] == mediafileId && blockIds.indexOf(mediafileBlocks[i][1]) !== -1) {
            return mediafileBlocks[i][1];
        }
    }
    return;
};
exports.blockPatternRule = blockPatternRule;
//# sourceMappingURL=blockPatternRule.js.map